export default __webpack_public_path__ + "static/media/arrowUp.951b848a.svg";